import { Components } from '@mui/material/styles/components';
import { Theme } from '@mui/material/styles';
//TODO: Добавлять сюда глобальные слили из SX
export const components: Components<Theme> = {
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--palette-background)',
      },
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--palette-primary-main)',
        color: 'var(--palette-text-primary)',
      },
    },
  },

  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: 'var(--palette-text-primary)',
      },
    },
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--palette-background-paper)',
        border: '1px solid var(--palette-divider)',
      },
    },
  },

  MuiCssBaseline: {
    styleOverrides: (theme) => ({
      body: {
        '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
          width: '4px',
          height: '4px',
          backgroundColor: theme.palette.background.paper,
        },
        '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
          borderRadius: '8px',
          backgroundColor: theme.palette.primary.light,
          minHeight: '24px',
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
        '&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
          backgroundColor: theme.palette.background.default,
        },
        '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
          backgroundColor: theme.palette.background.paper,
        },
      },
    }),
  },
};
